import { useAppStore } from 'kfone-frontend-core';
import { useCommonStore } from 'store';
import { getShortLocale } from 'shared/locales';

const syncLangKey = (primaryLanguage?: { value?: string } | null) => {
  const shortLangCode = getShortLocale(primaryLanguage?.value ?? 'en-US');
  useCommonStore.getState().updateLangKey(shortLangCode);
};

syncLangKey(useAppStore.getState().primaryLanguage);

useAppStore.subscribe((state, prevState) => {
  if (state.primaryLanguage !== prevState.primaryLanguage) {
    syncLangKey(state.primaryLanguage);
  }
});
